import { render, staticRenderFns } from "./AddDcs.vue?vue&type=template&id=54e5cac0&scoped=true&"
import script from "./AddDcs.vue?vue&type=script&lang=js&"
export * from "./AddDcs.vue?vue&type=script&lang=js&"
import style0 from "./AddDcs.vue?vue&type=style&index=0&id=54e5cac0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e5cac0",
  null
  
)

export default component.exports